export type ActivityColumnKey =
  | 'activity'
  | 'lesson'
  | 'unit'
  | 'klass'
  | 'student'
  | 'sentAt'
  | 'status'
  | 'actions';

export const PENDENCIES_ACTIVITY_COLUMN_ORDER: ActivityColumnKey[] = [
  'activity',
  'lesson',
  'unit',
  'klass',
  'student',
  'sentAt',
  'actions',
];

export const KLASS_ACTIVITY_COLUMN_ORDER: ActivityColumnKey[] = [
  'activity',
  'lesson',
  'unit',
  'student',
  'sentAt',
  'status',
  'actions',
];
